import axios from "axios";
import axiosInstance from "../utils/axiosInstance";
import { useState } from "react";
import { Link } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../utils/toast";
import LoadingSpinner from "./LoadingSpinner";
import DetailsModal from "./Modal/DetailsModal";

const BankCards= ({bankData,userId,consentHandleId,sessionId,id,cusName,fetchReports}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleDownloadExcel = async (bank) => {
    console.log(bank)
    setLoading(true);
    setErrorMessage("");
    try {
      const response = await axiosInstance.post("/account-aggregator/download-analytic-report-data",
       {
          userId:userId,
          consentHandleId: consentHandleId,
          sessionId: sessionId,
          linkRefNo: bank.linkAccountRefNo,
        },
      );

     showSuccessToast("report generated successfully")
     fetchReports()
    } catch (error) {
      showErrorToast(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const downloadExcel = async (bank, type) => {
    console.log(bank);
    setLoading(true);
    setErrorMessage("");
  
    try {
      const response = await axiosInstance.get("account-aggregator/downloadAnalyticReport", {
        params: {
          path: `${userId}/${cusName}-${bank.linkAccountRefNo}-account-aggregator.${type}`,
        },
      });
  
      // Assuming the response contains the URL in response.data.url
      const fileUrl = response.data.data;
      window.open(fileUrl, '_blank');
    } catch (error) {
      showErrorToast(error.response?.data?.message || "An error occurred while downloading the file.");
    } finally {
      setLoading(false);
    }
  };
  

    return (
      <div className="grid grid-cols-2 gap-6 ">
        {loading&&<LoadingSpinner />}
        
        {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Download Excel Report</h3>
            {loading ? (
            <LoadingSpinner/>
            ) : (
              <>
                <p>Click confirm to download the Excel report for this bank.</p>
                <div className="flex justify-end mt-4">
                  <button
                    className="px-4 py-2 mr-2 bg-gray-200 rounded hover:bg-gray-300"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                    onClick={() => {
                      setShowModal(false);
                      handleDownloadExcel(bankData[0]); // Pass the selected bank data
                    }}
                  >
                    Confirm
                  </button>
                </div>
              </>
            )}
            {errorMessage && (
              <p className="text-red-500 mt-2">{errorMessage}</p>
            )}
            {successMessage && (
              <p className="text-green-500 mt-2">{successMessage}</p>
            )}
          </div>
        </div>
      )}
        {!loading&&bankData?.map((bank,index) => (
          <div
            key={bank.bankInformationId}
            className="bg-white border border-gray-200 rounded-lg shadow-md p-4 w-full"
          >
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              {bank.bankName}
            </h3>
            <p className="text-sm text-gray-600">
              <strong>Branch:</strong> {bank.branchName}
            </p>
        
            <p className="text-sm text-gray-600">
              <strong>Account Number:</strong> {bank.maskedAccNumber}
            </p>
            <p className="text-sm text-gray-600">
              <strong>IFSC:</strong> {bank.ifsc}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Account Type:</strong> {bank.accountType}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Reference No:</strong> {bank.linkAccountRefNo}
            </p>
            <p className="text-sm text-gray-600">
              <strong>Bank Info Type:</strong> {bank.bankInfoType}
            </p>
            <div className="flex items-center gap-4 px-4 py-3">
      <Link
        to={`/accountAggregator/banks/${id}?userId=${userId}&bank=${index}`}
        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 text-sm text-center font-medium"
      >
        Bank Statement Report
      </Link>
      
      {!bank.pdfUrl&&<button
        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
        onClick={() => handleDownloadExcel(bank)}
      >
        Generate Report
      </button>}
    </div>
    {bank.pdfUrl&&<div className="flex items-center gap-4 px-4 py-3">
      <button
        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
        onClick={() => downloadExcel(bank,'pdf')}
      >
        Pdf
      </button>
      <DetailsModal
                log={bank.analyzeResponse}
                trigger={
                  <button       
                     className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
                    >
                    Json
                  </button>
                }
              />

      
   <button
        className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
        onClick={() => downloadExcel(bank,'xlsx')}
      >
        Excel
      </button>
    </div>}

          </div>
        ))}
      </div>
    );
  };
  
  export default BankCards;